export const checkoutSteps = ['Cuotas a pagar', 'Método de pago', 'Facturación', 'Pago'];
